const WSIMG =
  "https://img1.wsimg.com/isteam/ip/b66c0493-6c23-4d9e-b5ee-0c63810ac4ff";

export const BUSINESSES = [
  {
    slug: "eurovdc",
    name: "EuroVDC DataCenter",
    shortName: "EuroVDC",
    category: "Digital Infrastructure",
    location: "Bulgaria",
    year: "2024",
    tagline:
      "State-of-the-art data center infrastructure — fully operational in Bulgaria.",
    description:
      "Since 2016, the OA Holding team has proudly managed key operations at the esteemed SDC (Sofia Data Center), gaining invaluable expertise and earning a reputation for excellence in data center management. Building on this solid foundation, and driven by a vision to deliver world-class infrastructure solutions, OA Holding established the EuroVDC Datacenter in 2024. Now fully operational, EuroVDC stands as a state-of-the-art facility, equipped with cutting-edge technologies and comprehensive features designed to meet the diverse needs of businesses in today's digital landscape.",
    hero: `${WSIMG}/rsz_20220609_205344.webp/:/rs=w:1600,h:1000,cg:true`,
    gallery: [`${WSIMG}/rsz_20220609_205344.webp/:/rs=w:1200,h:800,cg:true`],
    metrics: [
      { raw: "2016", label: "Managing SDC operations since" },
      { raw: "2024", label: "EuroVDC established" },
    ],
    sections: [
      {
        title: "From SDC to EuroVDC",
        body: "Years of hands-on management of key operations at SDC (Sofia Data Center) gave the OA Holding team deep operational expertise and a reputation for excellence in data center management — the foundation on which EuroVDC was built.",
      },
      {
        title: "Fully Operational",
        body: "Established in 2024, EuroVDC is now a fully operational, state-of-the-art facility equipped with cutting-edge technologies and comprehensive features designed for the diverse needs of modern business.",
      },
    ],
  },
  {
    slug: "biduniq",
    name: "BidUniq",
    shortName: "BidUniq",
    category: "E-Commerce",
    location: "European Union",
    year: null,
    tagline:
      "An intelligent bidding platform for the market's most coveted items.",
    description:
      "BidUniq is a groundbreaking bidding platform designed to redefine how people engage with the market's most coveted and high-value items. Launched in the European Union, BidUniq leverages innovative technology to create a dynamic and intelligent bidding system, offering participants a unique opportunity to acquire premium products at remarkably low prices.",
    hero: `${WSIMG}/photo_2024-05-11_21-56-50.jpg/:/rs=w:1600,h:1000,cg:true`,
    gallery: [`${WSIMG}/photo_2024-05-11_21-56-50.jpg/:/rs=w:1200,h:800,cg:true`],
    metrics: [],
    sections: [
      {
        title: "A New Model for Smart Bidding",
        body: "BidUniq is not just a platform — it is a new approach to smart shopping, transforming the way people access the finest the market has to offer through a dynamic, intelligent bidding system.",
      },
    ],
  },
  {
    slug: "mv-artax",
    name: "MV ARTAX",
    shortName: "MV ARTAX",
    category: "Maritime",
    location: "Global trade routes",
    year: null,
    tagline:
      "A state-of-the-art bulk carrier built for efficient, reliable transportation of bulk commodities.",
    description:
      "The MV ARTAX is a state-of-the-art bulk carrier designed for efficient and reliable transportation of bulk commodities across global trade routes. Equipped with advanced technology and robust infrastructure, the vessel is capable of handling large volumes of cargo such as grains, minerals, coal, and other essential raw materials. The MV ARTAX stands as a symbol of strength and dependability in the maritime logistics sector, contributing to global trade with efficiency and precision.",
    hero: `${WSIMG}/artax_9623063_3106225_XLarge.jpg/:/rs=w:1600,h:1000,cg:true`,
    gallery: [
      `${WSIMG}/artax_9623063_3106225_XLarge.jpg/:/rs=w:1200,h:800,cg:true`,
      "https://images.unsplash.com/photo-1605745341112-85968b19335b?w=1400&q=80",
    ],
    metrics: [
      { value: 178, suffix: " / 29", label: "Dimensions — m" },
      { value: 22800, suffix: "", label: "Gross Tonnage — t" },
      { value: 37000, suffix: "", label: "Summer DWT — t" },
    ],
    sections: [
      {
        title: "Built for Bulk Commodities",
        body: "Grains, minerals, coal and other essential raw materials — the MV ARTAX handles large-volume cargo across global trade routes with advanced technology and robust infrastructure.",
      },
      {
        title: "Strength and Dependability",
        body: "A symbol of strength and dependability in the maritime logistics sector, contributing to global trade with efficiency and precision.",
      },
    ],
  },
  {
    slug: "paros-resort",
    name: "5-Star Hotel & Beach Resort",
    shortName: "Paros Resort",
    category: "Hospitality",
    location: "Paros Island, Greece",
    year: "2026",
    tagline:
      "A luxurious 5-star hotel and beach resort on the shores of Paros Island.",
    description:
      "OA Holding is proud to unveil its latest ambitious project — a luxurious 5-star hotel and beach resort set to grace the stunning shores of Paros Island, Greece. Scheduled to open in the summer of 2026, this extraordinary development will redefine luxury and hospitality in one of the most picturesque destinations in the Aegean. This milestone project reflects OA Holding's vision to blend innovative design, premium hospitality and timeless elegance.",
    hero: `${WSIMG}/image_2024-12-12_16-24-30.png/:/rs=w:1600,h:1000,cg:true`,
    gallery: [`${WSIMG}/image_2024-12-12_16-24-30.png/:/rs=w:1200,h:800,cg:true`],
    metrics: [{ raw: "2026", label: "Scheduled opening — summer" }],
    sections: [
      {
        title: "The Aegean, Redefined",
        body: "Set on the shores of Paros Island in one of the most picturesque destinations in the Aegean, the resort blends innovative design, premium hospitality and timeless elegance.",
      },
    ],
  },
  {
    slug: "softmaya",
    name: "SoftMaya LTD",
    shortName: "SoftMaya",
    category: "Technology",
    location: null,
    year: null,
    tagline:
      "The strategic execution layer for OA Holding's advanced technology solutions.",
    description:
      "SoftMaya LTD operates as a strategic execution layer for the advanced technology solutions developed and controlled by OA Holding. Through SoftMaya, OA Holding deploys and manages high-performance infrastructure, proprietary software and scalable digital systems across global markets. SoftMaya is not merely a service provider — it is the operational multiplier that enables OA Holding's proprietary technology to scale globally.",
    hero: "https://images.unsplash.com/photo-1506399309177-3b43e99fead2?w=1600&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1506399309177-3b43e99fead2?w=1200&q=80",
    ],
    metrics: [],
    items: [
      "High-scale server architectures, engineered by OA Holding, deployed and operated through SoftMaya",
      "iGaming backend systems, data flows and performance optimization layers, designed at holding level and executed via SoftMaya",
      "Advanced content delivery and access technologies for seamless global availability of gaming content",
      "International network optimization, intelligent routing and proprietary tunneling infrastructures, developed and controlled by OA Holding",
    ],
    sections: [
      {
        title: "The Operational Multiplier",
        body: "SoftMaya enables OA Holding's proprietary technology to scale globally — deploying high-performance infrastructure, proprietary software and scalable digital systems across global markets.",
      },
    ],
  },
  {
    slug: "ozzlabs",
    name: "OZZLABS",
    shortName: "OZZLABS",
    category: "AI & Innovation",
    location: "Dubai",
    year: null,
    tagline:
      "OA Holding's dedicated innovation and R&D arm for artificial intelligence and next-generation communication.",
    description:
      "OZZLABS is OA Holding's dedicated innovation and R&D arm, focused on artificial intelligence and next-generation communication technologies. Through OZZLABS, OA Holding develops, productizes and commercializes advanced AI-driven systems. OZZLABS represents OA Holding's forward-looking investment in AI, privacy-focused communication and decentralized digital infrastructure.",
    hero: "https://customer-assets.emergentagent.com/job_793f4d9e-0301-4720-bb01-23c7fefcbee2/artifacts/n0gzplx0_Gemini_Generated_Image_kis0m0kis0m0kis0.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_793f4d9e-0301-4720-bb01-23c7fefcbee2/artifacts/n0gzplx0_Gemini_Generated_Image_kis0m0kis0m0kis0.jpg",
    ],
    metrics: [],
    items: [
      "AI-powered website generation and automated content creation engines, developed at holding level and delivered through OZZLABS",
      "Real-time, ultra-low latency peer-to-peer (P2P) video communication infrastructures",
      "Proprietary communication protocols enabling direct, on-demand connections with minimal reliance on public network layers",
      "Ephemeral, link-based communication systems designed to leave no residual data footprint once a session ends",
    ],
    sections: [
      {
        title: "Forward-Looking Investment",
        body: "OZZLABS represents OA Holding's forward-looking investment in AI, privacy-focused communication and decentralized digital infrastructure.",
      },
    ],
  },
];

export const getBusiness = (slug) => BUSINESSES.find((b) => b.slug === slug);
